import React from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

/**
 * Drop-in replacement for MUI Button.
 * Pass `loading={true}` to show a spinner and disable the button.
 * All other Button props are forwarded as-is.
 */
const LoadingButton = ({ loading = false, children, startIcon, disabled, style, ...rest }) => {
  return (
    <Button
      {...rest}
      disabled={loading || disabled}
      startIcon={
        loading ? (
          <CircularProgress size={16} thickness={5} color="inherit" style={{ marginRight: 2 }} />
        ) : (
          startIcon
        )
      }
      style={{ minWidth: 90, ...style }}
    >
      {children}
    </Button>
  );
};

export default LoadingButton;
